var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"68f908a88b23aef04bc46642f5764cccf4f2c353"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["app-web@treefort-systems"]={id:"68f908a88b23aef04bc46642f5764cccf4f2c353"};
      